var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeveloper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 513",
    width: 513,
    height: 513,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nuevo proyecto") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-204-2h956v535.84h-956z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #6f4c29 } \r\n\t\t.s1 { fill: #000000 } \r\n\t\t.s2 { opacity: .2;fill: #000000 } \r\n\t\t.s3 { fill: #828286;stroke: #000000;strokeWidth: 2.4 } \r\n\t\t.s4 { fill: #c4c4c4 } \r\n\t\t.s5 { fill: #192228 } \r\n\t\t.s6 { opacity: .6;fill: #2a3b47 } \r\n\t\t.s7 { opacity: .6;fill: #000000 } \r\n\t\t.s8 { opacity: .6;fill: #3d5567 } \r\n\t\t.s9 { opacity: .6;fill: #1b252d } \r\n\t\t.s10 { opacity: .6;fill: #66d1ff } \r\n\t\t.s11 { opacity: .6;fill: #51e199 } \r\n\t\t.s12 { opacity: .6;fill: #eb5757 } \r\n\t\t.s13 { opacity: .6;fill: #ffc757 } \r\n\t\t.s14 { opacity: .6;fill: #2cd37f } \r\n\t\t.s15 { fill: #2a3b47 } \r\n\t\t.s16 { fill: #3d5567 } \r\n\t\t.s17 { fill: #1b252d } \r\n\t\t.s18 { fill: #66d1ff } \r\n\t\t.s19 { fill: #51e199 } \r\n\t\t.s20 { fill: #eb5757 } \r\n\t\t.s21 { fill: #ffc757 } \r\n\t\t.s22 { fill: #2cd37f } \r\n\t\t.s23 { fill: #063353;stroke: #000000;strokeLinejoin: round;stroke-width: 2 } \r\n\t\t.s24 { opacity: .3;fill: #000000 } \r\n\t\t.s25 { fill: #dadada } \r\n\t\t.s26 { fill: #edac7c } \r\n\t\t.s27 { fill: #f7a588 } \r\n\t\t.s28 { fill: #cf9166 } \r\n\t\t.s29 { fill: #edac7c;stroke: #000000;strokeLinejoin: round;stroke-width: 2 } \r\n\t\t.s30 { fill: none;stroke: #000000;strokeLinejoin: round;stroke-width: 2 } \r\n\t\t.s31 { fill: #482517 } \r\n\t\t.s32 { fill: #3d1d10;stroke: #000000;strokeLinejoin: round;stroke-width: 2 } \r\n\t\t.s33 { fill: #3d1d10 } \r\n\t\t.s34 { fill: #43382d;stroke: #000000;strokeLinejoin: round;stroke-width: 2 } \r\n\t\t.s35 { fill: #697477;stroke: #000000;strokeLinejoin: round;stroke-width: 2 } \r\n\t\t.s36 { fill: #a0a7ac;stroke: #000000;strokeLinejoin: round;stroke-width: 2 } \r\n\t\t.s37 { fill: #889297;stroke: #000000;strokeLinejoin: round;stroke-width: 2 } \r\n\t\t.s38 { fill: #4d5557 } \r\n\t\t.s39 { fill: #232f38;stroke: #000000;strokeLinejoin: round;stroke-width: 2 } \r\n\t\t.s40 { fill: #33424e;stroke: #000000;strokeLinejoin: round;stroke-width: 2 } \r\n\t\t.s41 { fill: #232f38;stroke: #000000;strokeLinejoin: round;stroke-width: 1.4 } \r\n\t\t.s42 { fill: #ecf4ff } \r\n\t\t.s43 { fill: #ddeafb } \r\n\t\t.s44 { fill: #477b9e } \r\n\t\t.s45 { fill: #3f6d8e } \r\n\t\t.s46 { fill: #bed8fb } \r\n\t\t.s47 { fill: #7fb3fa } \r\n\t\t.s48 { fill: #ffe07d } \r\n\t\t.s49 { fill: #ffd064 } \r\n\t\t.s50 { fill: #e28086 } \r\n\t\t.s51 { fill: #dd636e } \r\n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m73.7 327.8c0-4.1 2.3-7.6 5.1-7.6h375.2c2.9 0 5.1 3.5 5.1 7.6 0 4.3-2.4 7.6-5.1 7.6h-375.2c-2.8 0-5.1-3.3-5.1-7.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m70.2 327.6c0-2.7 0.8-5.3 2-7.4 1.3-2 3.7-3.9 6.6-3.9h375.2c2.9 0 5.2 1.9 6.5 3.9 1.3 1.9 2.1 4.7 2.1 7.4 0 2.8-0.8 5.3-2.1 7.5-1.3 2-3.5 3.8-6.5 3.8h-375.2c-2.9 0-5.3-1.8-6.6-3.8-1.2-2-2-4.7-2-7.5zm388.9 0.2c0-4.1-2.4-7.6-5.1-7.6h-375.2c-2.9 0-5.1 3.5-5.1 7.6 0 4.3 2.3 7.6 5.1 7.6h375.2c2.7 0 5.1-3.3 5.1-7.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m458.7 330.7c-0.9 2.8-2.8 4.7-4.7 4.7h-375.2c-2 0-3.9-1.9-4.5-4.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m173.7 308.4c0-0.6 0.5-1 1-1h210.9c0.6 0 1 0.4 1 1v6.2c0 0.5-0.4 1-1 1h-210.9c-0.5 0-1-0.5-1-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m168 311.3c0-1.6 1.3-2.9 2.9-2.9h214c1.6 0 2.9 1.3 2.9 2.9v9.2c0 1.6-1.3 2.9-2.9 2.9h-214c-1.6 0-2.9-1.3-2.9-2.9zm3.5 7.8c0 0.6 0.5 1 1 1h210.9c0.6 0 1-0.4 1-1v-6.2c0-0.5-0.4-1-1-1h-210.9c-0.5 0-1 0.5-1 1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m89.1 58.6c0-10.9 8.8-19.7 19.7-19.7h321.1c10.9 0 19.7 8.8 19.7 19.7v194.8c0 10.9-8.8 19.7-19.7 19.7h-321.1c-10.9 0-19.7-8.8-19.7-19.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m91.3 59.6c0-10.2 8.3-18.5 18.5-18.5h319.1c10.2 0 18.5 8.3 18.5 18.5v189.2c0 10.3-8.3 18.5-18.5 18.5h-319.1c-10.2 0-18.5-8.2-18.5-18.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m99.7 59.8c0-5.4 4.4-9.7 9.7-9.7h319.9c5.4 0 9.7 4.3 9.7 9.7v189.2c0 5.4-4.3 9.7-9.7 9.7h-319.9c-5.3 0-9.7-4.3-9.7-9.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m98.1 67.7c0-10.7 8.7-19.4 19.5-19.4h303.9c10.7 0 19.6 8.7 19.6 19.4v173.4c0 10.7-8.9 19.5-19.6 19.5h-304.1c-10.7 0-19.4-8.8-19.4-19.5v-173.4zm19.2-16c-8.8 0-15.8 7.1-15.8 15.8v173.4c0 8.8 7 15.9 15.8 15.9h304c8.8 0 15.8-7.1 15.8-15.9v-173.2c0-8.7-7-15.8-15.8-15.8h-304z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.6
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m348 249.3h-79.5v-100.9h120.4v96c0 0 0.2 4.7-4.3 4.7-6.7 0-36.6 0.2-36.6 0.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s7",
    d: "m267.9 148.3c0-0.6 0.3-1 0.9-1h120.3c0.6 0 0.9 0.4 0.9 1v96.9c0 0.5-0.1 1.2-0.5 1.9-0.4 0.8-0.7 1.5-1.7 2-0.6 0.6-1.7 1-3 1h-116c-0.6 0-0.9-0.4-0.9-1zm80.1 100h36.6c0.9 0 1.6-0.1 2-0.6 0.4-0.3 0.7-0.6 0.9-1.2 0.2-0.5 0.3-1.1 0.3-1.5v-95.9h-118.5v99.1h78.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m268.8 148.3v100.8h-5.5c-2.6 0-2.7-2.7-2.7-2.7v-98.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s7",
    d: "m259.6 148.3c0-0.6 0.4-1 1-1h8.2c0.5 0 0.8 0.4 0.8 1v100.8c0 0.6-0.3 1-0.8 1h-5.5c-1.6 0-2.7-1-3.2-1.9-0.1-0.3-0.3-0.8-0.3-1.1v-98.8zm1.9 98.1v0.2c0 0.2 0.1 0.3 0.1 0.8 0.2 0.3 0.7 0.8 1.5 0.8h4.6v-99.1h-6.5v97.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m388.9 148.3h-128.5v-5.5c0-3.1 2.4-5.4 5.4-5.4h117.7c3.1 0 5.4 2.3 5.4 5.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s7",
    d: "m259.6 142.8c0-3.5 2.9-6.4 6.4-6.4h117.7c3.6 0 6.3 2.9 6.3 6.4v5.5c0 0.5-0.3 0.8-0.9 0.8h-128.5c-0.6 0-1-0.3-1-0.8zm6.4-4.6c-2.6 0-4.6 2-4.6 4.6v4.4h126.9v-4.4c0-2.6-2.1-4.6-4.6-4.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m331.6 161.9h-52.1c-1.5 0-2.8-1.3-2.8-2.7 0-1.5 1.3-2.7 2.8-2.7h52.1c1.4 0 2.8 1.2 2.8 2.7 0 1.4-1.1 2.7-2.8 2.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m339.8 172.8h-54.9c-1.4 0-2.7-1.3-2.7-2.7 0-1.4 1.3-2.7 2.7-2.7h54.9c1.4 0 2.7 1.3 2.7 2.7 0 1.4-1.1 2.7-2.7 2.7zm-16.4 54.7h-38.3c-1.4 0-2.7-1.3-2.7-2.7 0-1.6 1.3-2.8 2.7-2.8h38.3c1.5 0 2.8 1.2 2.8 2.8 0 1.4-1.1 2.7-2.8 2.7zm33-54.7h-5.5c-1.5 0-2.8-1.3-2.8-2.7 0-1.4 1.3-2.7 2.8-2.7h5.5c1.4 0 2.7 1.3 2.7 2.7 0 1.4-1.3 2.7-2.7 2.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m296 238.4h-16.3c-1.4 0-2.8-1.3-2.8-2.7 0-1.5 1.4-2.7 2.8-2.7h16.3c1.6 0 2.8 1.2 2.8 2.7 0 1.4-1.2 2.7-2.8 2.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m370 183.7h-57.6c-1.4 0-2.7-1.3-2.7-2.7 0-1.4 1.3-2.7 2.7-2.7h57.6c1.5 0 2.8 1.3 2.8 2.7 0 1.4-1.3 2.7-2.8 2.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m326.2 194.7h-35.6c-1.4 0-2.7-1.2-2.7-2.8 0-1.4 1.3-2.7 2.7-2.7h35.6c1.4 0 2.7 1.3 2.7 2.7 0 1.6-1.1 2.8-2.7 2.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m348.1 216.6h-57.5c-1.4 0-2.7-1.3-2.7-2.8 0-1.5 1.3-2.8 2.7-2.8h57.5c1.5 0 2.8 1.3 2.8 2.8 0 1.5-1.3 2.8-2.8 2.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m348.1 205.6h-38.2c-1.4 0-2.7-1.2-2.7-2.8 0-1.4 1.3-2.7 2.7-2.7h38.2c1.5 0 2.8 1.3 2.8 2.7 0 1.6-1.3 2.8-2.8 2.8zm-49.3 0h-8.2c-1.4 0-2.7-1.2-2.7-2.8 0-1.4 1.3-2.7 2.7-2.7h8.2c1.5 0 2.7 1.3 2.7 2.7 0 1.6-1.2 2.8-2.7 2.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m301.5 183.7h-10.9c-1.4 0-2.7-1.3-2.7-2.7 0-1.4 1.3-2.7 2.7-2.7h10.9c1.5 0 2.7 1.3 2.7 2.7 0 1.4-1.2 2.7-2.7 2.7z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m268.8 145.5c-1.5 0-2.8-1.2-2.8-2.7 0-1.5 1.3-2.7 2.8-2.7 1.5 0 2.7 1.2 2.7 2.7 0 1.5-1.2 2.7-2.7 2.7z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m276.9 145.5c-1.5 0-2.7-1.2-2.7-2.7 0-1.5 1.2-2.7 2.7-2.7 1.6 0 2.8 1.2 2.8 2.7 0 1.5-1.2 2.7-2.8 2.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m285.1 145.5c-1.5 0-2.7-1.2-2.7-2.7 0-1.5 1.2-2.7 2.7-2.7 1.5 0 2.8 1.2 2.8 2.7 0 1.5-1.3 2.7-2.8 2.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.6
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m227.7 245.8h-79.3v-100.8h120.4v96.1c0 0 0.2 4.7-4.4 4.7z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s7",
    d: "m147.4 144.8c0-0.6 0.4-0.9 1-0.9h120.4c0.5 0 0.8 0.3 0.8 0.9v96.9c0 0.5-0.1 1.2-0.5 2-0.3 0.7-0.7 1.5-1.6 2-0.7 0.6-1.8 0.9-3.1 0.9h-116c-0.6 0-1-0.3-1-0.9zm80.3 100.1h36.7c0.9 0 1.6-0.1 2-0.5 0.5-0.4 0.7-0.7 0.9-1.2 0.2-0.6 0.4-1 0.4-1.6v-95.9h-118.7v99.1h78.7z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m148.4 144.8v100.9h-5.5c-2.6 0-2.7-2.8-2.7-2.8v-98.1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s7",
    d: "m139.2 144.8c0-0.6 0.5-0.9 1-0.9h8.2c0.5 0 0.9 0.3 0.9 0.9v100.9c0 0.6-0.4 0.9-0.9 0.9h-5.5c-1.6 0-2.7-0.9-3.1-1.9-0.1-0.3-0.4-0.8-0.4-1v-98.9zm1.9 98.3v0.2c0 0.1 0.1 0.4 0.1 0.7 0.2 0.4 0.8 1 1.5 1h4.5v-99.1h-6.3v97.2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m268.8 144.8h-128.6v-5.5c0-3 2.3-5.4 5.5-5.4h117.6c3.1 0 5.5 2.4 5.5 5.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s7",
    d: "m139.2 139.3c0-3.5 3-6.3 6.5-6.3h117.6c3.5 0 6.3 2.8 6.3 6.3v5.5c0 0.5-0.3 0.9-0.8 0.9h-128.6c-0.5 0-1-0.4-1-0.9zm6.5-4.4c-2.7 0-4.6 2-4.6 4.6v4.5h126.8v-4.5c0-2.6-2.1-4.6-4.6-4.6z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m211.2 158.4h-52.1c-1.4 0-2.7-1.3-2.7-2.7 0-1.4 1.3-2.7 2.7-2.7h52.1c1.5 0 2.8 1.3 2.8 2.7 0.1 1.4-1.1 2.7-2.8 2.7z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m219.5 169.3h-54.7c-1.5 0-2.8-1.2-2.8-2.7 0-1.4 1.3-2.7 2.8-2.7h54.7c1.6 0 2.8 1.3 2.8 2.7 0 1.5-1.2 2.7-2.8 2.7zm-16.5 54.7h-38.5c-1.4 0-2.7-1.3-2.7-2.7 0-1.4 1.3-2.7 2.7-2.7h38.5c1.5 0 2.7 1.3 2.7 2.7 0 1.4-1.1 2.7-2.7 2.7zm33-54.7h-5.5c-1.5 0-2.8-1.2-2.8-2.7 0-1.4 1.3-2.7 2.8-2.7h5.5c1.4 0 2.8 1.3 2.8 2.7 0 1.5-1.4 2.7-2.8 2.7z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m175.7 234.9h-16.4c-1.4 0-2.7-1.3-2.7-2.7 0-1.4 1.3-2.7 2.7-2.7h16.4c1.4 0 2.7 1.3 2.7 2.7 0 1.4-1.3 2.7-2.7 2.7z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m249.7 180.3h-57.7c-1.4 0-2.7-1.2-2.7-2.8 0-1.4 1.3-2.7 2.7-2.7h57.7c1.4 0 2.7 1.3 2.7 2.7 0 1.6-1.3 2.8-2.7 2.8z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m205.7 191.3h-35.5c-1.4 0-2.7-1.3-2.7-2.8 0-1.5 1.3-2.8 2.7-2.8h35.5c1.5 0 2.8 1.3 2.8 2.8 0 1.5-1.1 2.8-2.8 2.8z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m227.7 213.1h-57.5c-1.4 0-2.7-1.3-2.7-2.7 0-1.6 1.3-2.8 2.7-2.8h57.5c1.6 0 2.8 1.2 2.8 2.8 0 1.4-1.2 2.7-2.8 2.7z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m227.7 202.2h-38.2c-1.4 0-2.7-1.3-2.7-2.7 0-1.6 1.3-2.8 2.7-2.8h38.2c1.6 0 2.8 1.2 2.8 2.8 0 1.4-1.2 2.7-2.8 2.7zm-49.3 0h-8.2c-1.4 0-2.7-1.3-2.7-2.7 0-1.6 1.3-2.8 2.7-2.8h8.2c1.5 0 2.7 1.2 2.7 2.8 0 1.4-1.2 2.7-2.7 2.7z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m181.1 180.3h-10.9c-1.4 0-2.7-1.2-2.7-2.8 0-1.4 1.3-2.7 2.7-2.7h10.9c1.6 0 2.8 1.3 2.8 2.7 0 1.6-1.2 2.8-2.8 2.8z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m148.4 142.1c-1.5 0-2.7-1.3-2.7-2.8 0-1.5 1.2-2.7 2.7-2.7 1.5 0 2.7 1.2 2.7 2.7 0 1.5-1.2 2.8-2.7 2.8z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m156.6 142.1c-1.5 0-2.8-1.3-2.8-2.8 0-1.5 1.3-2.7 2.8-2.7 1.5 0 2.7 1.2 2.7 2.7 0 1.5-1.2 2.8-2.7 2.8z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m164.8 142.1c-1.6 0-2.8-1.3-2.8-2.8 0-1.5 1.2-2.7 2.8-2.7 1.5 0 2.7 1.2 2.7 2.7 0 1.5-1.2 2.8-2.7 2.8z"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m166.6 167.4h-114.6v-145.7h173.5v138.8c0 0 0.3 6.9-6.1 6.9z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m50.7 21.9c0-0.8 0.6-1.3 1.3-1.3h173.5c0.8 0 1.4 0.5 1.4 1.3v139.8c0 0.8-0.4 1.9-0.8 2.7-0.3 1.1-1.1 2.2-2.3 3q-1.6 1.3-4.6 1.3h-167.4c-0.6 0-1.2-0.6-1.2-1.3v-145.5zm168.6 144.2c1.3 0 2.4-0.4 3-0.7 0.6-0.5 1.1-1.1 1.4-1.8 0.3-0.8 0.5-1.5 0.5-2v-138.3h-170.8v142.8z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m52.2 21.9v145.7h-7.8c-3.6 0-4.1-4-4.1-4v-141.7z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m39.1 21.9c0-0.8 0.6-1.3 1.2-1.3h11.9c0.7 0 1.2 0.5 1.2 1.3v145.7c0 0.6-0.5 1.2-1.2 1.2h-7.8c-2.5 0-3.8-1.2-4.6-2.7-0.3-0.6-0.5-1.2-0.5-1.7 0-0.1 0-0.3-0.2-0.5zm2.6 142.1c0 0.3 0.2 0.7 0.3 0.8 0.4 0.8 1 1.4 2.2 1.4h6.5v-143h-9z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m225.8 21.9h-185.5v-7.9c0-4.3 3.5-7.8 7.9-7.8h169.7c4.4 0 7.9 3.5 7.9 7.8z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m38.9 13.8c0-5.1 4.2-9.3 9.3-9.3h169.7c5.1 0 9.3 4.2 9.3 9.3v7.9c0 0.7-0.6 1.3-1.2 1.3h-185.7c-0.6 0-1.2-0.6-1.2-1.3v-7.9zm9.3-6.3c-3.7 0-6.5 2.8-6.5 6.5v6.6h182.6v-6.6c0-3.7-2.9-6.5-6.6-6.5z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m142.9 41.5h-75.1c-2.1 0-4-1.8-4-4 0-2.2 1.9-4 4-4h75.1c2.2 0 4 1.8 4 4 0 2.2-1.8 4-4 4z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m154.7 57.1h-79c-2.2 0-4-1.7-4-3.9 0-2.2 1.8-4 4-4h79c2.2 0 4.1 1.8 4.1 4 0 2.2-1.9 3.9-4.1 3.9zm-23.7 79h-55.3c-2.2 0-4-1.9-4-4.1 0-2.2 1.8-4 4-4h55.3c2.2 0 4.1 1.8 4.1 4 0 2.2-1.9 4.1-4.1 4.1zm47.4-79h-7.9c-2.1 0-3.9-1.7-3.9-3.9 0-2.2 1.8-4 3.9-4h7.9c2.2 0 4 1.8 4 4 0 2.2-1.8 3.9-4 3.9z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m91.5 151.7h-23.7c-2.1 0-4-1.8-4-4 0-2.2 1.9-4 4-4h23.7c2.2 0 4.1 1.8 4.1 4 0 2.2-1.9 4-4.1 4z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m198.3 73h-82.9c-2.2 0-4-1.8-4-4 0-2.1 1.8-4 4-4h82.9c2.1 0 4 1.9 4 4 0 2.2-1.9 4-4 4z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m135.1 88.7h-51.4c-2.2 0-4-1.9-4-4 0-2.2 1.8-4 4-4h51.4c2.2 0 4 1.8 4 4 0 2.1-1.8 4-4 4z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m166.6 120.2h-83c-2.2 0-4.1-1.8-4.1-4 0-2.2 1.9-4 4.1-4h83c2.2 0 3.9 1.8 3.9 4 0 2.2-1.7 4-3.9 4z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m166.7 104.4h-55.3c-2.2 0-4-1.9-4-4 0-2.2 1.8-4.1 4-4.1h55.3c2.2 0 4.1 1.9 4.1 4.1-0.3 2.3-1.9 4-4.1 4zm-71.1 0h-11.9c-2.2 0-4-1.9-4-4 0-2.2 1.8-4.1 4-4.1h11.9c2.2 0 4 1.9 4 4.1 0 2.3-1.8 4-4 4z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m99.6 73h-15.9c-2.2 0-4-1.8-4-4 0-2.1 1.8-4 4-4h15.9c2.2 0 3.9 1.9 3.9 4-0.1 2.2-1.7 4-3.9 4z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m52.2 17.9c-2.2 0-4-1.8-4-4.1 0-2.2 1.8-4 4-4 2.3 0 4.1 1.8 4.1 4 0 2.3-1.8 4.1-4.1 4.1z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m64 17.9c-2.2 0-4-1.8-4-4.1 0-2.2 1.8-4 4-4 2.3 0 4.1 1.8 4.1 4 0 2.3-1.8 4.1-4.1 4.1z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m75.9 17.9c-2.2 0-4-1.8-4-4.1 0-2.2 1.8-4 4-4 2.3 0 4.1 1.8 4.1 4 0 2.3-1.8 4.1-4.1 4.1z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m431.9 167.6h-113.6v-144.5h172.3v137.5c0 0 0.1 7-6.2 7z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m317 23c0-0.8 0.5-1.3 1.3-1.3h172.3c0.7 0 1.2 0.5 1.2 1.3v138.7c0 0.8-0.1 1.6-0.6 2.7-0.6 1.1-1.1 2.2-2.4 3q-1.7 1.3-4.6 1.3h-166.1c-0.8 0-1.3-0.6-1.3-1.3v-144.4zm167.4 143.3c1.4 0 2.2-0.3 2.9-0.8 0.7-0.5 1.1-1.1 1.5-1.7 0.3-0.8 0.5-1.6 0.5-2.1v-137.3h-169.7v141.9z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m318.3 23v144.6h-7.8c-3.7 0-4.1-3.8-4.1-3.8v-140.7h11.9z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m305.3 23c0-0.8 0.6-1.3 1.3-1.3h11.7c0.7 0 1.2 0.5 1.2 1.3v144.6c0 0.6-0.5 1.2-1.2 1.2h-7.8c-2.6 0-3.9-1.2-4.6-2.7-0.4-0.6-0.6-1.2-0.6-1.7zm2.6 140.7v0.3c0 0.4 0.1 0.8 0.4 0.9 0.3 0.8 0.8 1.3 2.2 1.3h6.3v-141.9h-9.1v139.4z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m490.6 23h-184v-7.9c0-4.3 3.5-7.8 7.9-7.8h168.4c4.3 0 7.8 3.5 7.8 7.8v7.9z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m305.2 15.1c0-5.1 3.9-9.1 9.1-9.1h168.5c5 0 9 4 9 9.1v7.9c0 0.6-0.5 1.2-1.2 1.2h-184.2c-0.6 0-1.2-0.6-1.2-1.2zm9.3-6.4c-3.7 0-6.6 2.9-6.6 6.5v6.5h181.4v-6.5c0-3.6-2.9-6.5-6.5-6.5z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m408.5 42.4h-74.6c-2.2 0-3.9-1.8-3.9-3.8 0-2.2 1.7-3.8 3.9-3.8h74.6c2.1 0 4 1.8 4 3.8 0 2.2-1.9 3.8-4 3.8z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m420.2 58.1h-78.2c-2.2 0-4-1.8-4-3.8 0-2.1 1.8-3.8 4-3.8h78.2c2.2 0 4.1 1.7 4.1 3.8 0 2-1.9 3.8-4.1 3.8zm-23.4 78.3h-54.8c-2.2 0-4-1.8-4-3.8 0-2.2 1.8-3.9 4-3.9h54.8c2.2 0 3.8 1.9 3.8 3.9 0 2-1.6 3.8-3.8 3.8zm47-78.3h-7.8c-2.2 0-3.9-1.8-3.9-3.8 0-2.1 1.9-3.8 3.9-3.8h7.8c2.2 0 3.9 1.7 3.9 3.8 0 2-1.7 3.8-3.9 3.8z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m357.5 151.9h-23.6c-2.2 0-3.9-1.9-3.9-3.8 0-2.2 1.7-3.9 3.9-3.9h23.6c2.2 0 3.9 1.9 3.9 3.9 0 2.1-1.7 3.8-3.9 3.8z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m463.5 73.7h-82.3c-2.2 0-4.1-1.8-4.1-3.8 0-1.9 1.9-3.8 4.1-3.8h82.3c2.1 0 3.8 1.9 3.8 3.8 0 2-1.7 3.8-3.8 3.8z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m400.6 89.5h-51c-2.2 0-4-1.9-4-3.9 0-2 1.8-3.8 4-3.8h51c2.2 0 4 1.8 4 3.8 0 2-1.8 3.9-4 3.9z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m431.9 120.8h-82.3c-2.2 0-4-1.9-4-3.8 0-2.2 1.8-3.9 4-3.9h82.3c2.2 0 4.1 1.8 4.1 3.9 0 1.9-1.9 3.8-4.1 3.8z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m432.1 105.1h-54.8c-2.2 0-4-1.9-4-3.9 0-2.1 1.8-3.8 4-3.8h54.8c2.2 0 4.1 1.9 4.1 3.8-0.2 2-1.9 3.9-4.1 3.9zm-70.7 0h-11.8c-2.2 0-4-1.9-4-3.9 0-2.1 1.8-3.8 4-3.8h11.8c2.2 0 3.8 1.9 3.8 3.8 0 2-1.6 3.9-3.8 3.9z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m365.2 73.7h-15.6c-2.2 0-4-1.8-4-3.8 0-1.9 1.8-3.8 4-3.8h15.6c2.2 0 4.1 1.9 4.1 3.8 0 2-1.9 3.8-4.1 3.8z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m318.4 19.1c-2.2 0-3.9-1.7-3.9-3.9 0-2.1 1.7-3.8 3.9-3.8 2.2 0 3.9 1.7 3.9 3.8 0 2.2-1.7 3.9-3.9 3.9z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m330.1 19.1c-2.2 0-3.9-1.7-3.9-3.9 0-2.1 1.7-3.8 3.9-3.8 2.2 0 3.9 1.7 3.9 3.8 0 2.2-1.7 3.9-3.9 3.9z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m341.9 19.1c-2.2 0-3.9-1.7-3.9-3.9 0-2.1 1.7-3.8 3.9-3.8 2.2 0 3.9 1.7 3.9 3.8 0 2.2-1.7 3.9-3.9 3.9z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s23",
    d: "m262.9 314.2c0.6 0 64.1 0 64.8 0l-66.6 1.6c0-0.9 0.9-1.6 1.8-1.6zm66.3 0.2l-68.1 1.4v46.5c0 0.9 0.9 1.6 1.8 1.6h49.5l-17.4 102.5c0 0.5 0 0.9 0.4 1.4 0.3 0.5 0.9 0.6 1.4 0.6h37c0.9 0 1.6-0.6 1.8-1.2l25.7-110.3c5.2-20.2-9.7-40.6-32.3-42.7h-1.3q0.6 0.1 1.5 0.2z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s23",
    d: "m266.6 313.9c1.1 0 1.8 0.8 1.8 1.7v47.2c0 0.9-0.7 1.7-1.8 1.7h-49.6l17.5 103.5c0 0.6 0 1.1-0.3 1.5-0.5 0.4-1 0.6-1.6 0.6h-36.8c-1 0-1.7-0.6-1.9-1.3l-25.9-111.3c-5.2-20.4 9.6-40.9 32.2-43.1zm-66.2 0.1c1.3-0.1 2.4-0.1 3.5-0.1zm66.2-0.2h-62.8zm0 0h-62.8z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m297.6 464.8l17.5-104.6h-51.7v-13.1h82.4c-0.2 0.3-0.2 0.8-0.2 1.1-0.2 1.4-0.3 3.1-0.6 4.6 0 0.3-0.2 1.2-0.3 2.5l-1.6 8.7c-3.2 14.2-7.1 28.3-11.4 42.3-3.9 13-8.2 44.1-12.3 57-0.2 0.4-0.2 0.7-0.4 1.1z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m266.6 362.9h-51.7l17.6 105.7h-13.8c-2-7.3-3.5-32.8-5.5-40.1-3.3-12.3-7.8-24.4-12.2-36.5-4.4-12.5-9-24.8-12.3-37.6-0.5-1.6-0.8-3.1-1.1-4.6h79z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m295.2 450.4h32.4c0 0 34.6 3.1 34.6 24.7h-67z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m327.9 447.5l-0.3 2.9h-32.4v24.7h67c0-1.1 0-1.9-0.2-2.8-2.9-19.2-34.4-21.9-34.4-21.9l0.3-2.9h0.6c0.4 0 0.7 0 1 0.1 1 0.2 2.4 0.5 4.3 0.8 3.4 0.8 7.8 1.8 12.6 3.6 8.9 3.7 19.1 10.6 19.1 23.3 0 1.7-1.5 3-3.1 3h-67c-1.6 0-3.2-1.3-3.2-3v-24.7c0-1.7 1.6-3 3.2-3h32.4c0-0.1 0.1-0.1 0.1-0.1z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m234.8 474.8h-68.6c0-21.7 35.6-24.8 35.6-24.8h33.2z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m201.5 447.1h33.8c1.8 0 3 1.3 3 2.9v24.8c0 1.6-1.4 2.9-3 2.9h-68.7c-1.8 0-3.2-1.3-3.2-2.9 0-12.8 10.4-19.6 19.8-23.4 4.7-1.7 9.3-2.8 12.7-3.6 1.8-0.3 3.1-0.5 4.2-0.7 0.6 0 0.9-0.1 1.2-0.1-0.1 0.1 0 0.1 0.2 0.1l0.4 2.9c0 0-32.2 2.8-35.2 21.9-0.1 0.9-0.1 2-0.1 2.9h68.7v-24.8h-33.4z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m228.5 128c-16.4 4-25.9-20.5-16.9-27.3 9-6.8 16.9 5.7 16.9 5.7z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m228.5 114.6v11.1c-14 1.1-19.9-18.8-13.3-20.8 5.3-1.5 10.9 5.8 13.3 9.7z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m212.3 107.8v-0.7c0-0.4 0-0.7 0.1-1.1 0-0.4 0.5-0.9 0.8-1.3 0.2-0.2 0.3-0.3 0.8-0.5 0.1 0 0.3-0.2 0.5-0.2h0.6c0.1-0.1 0.3-0.1 0.5-0.1 0.1-0.3 0.3-0.3 0.6-0.3h1.1q1 0 2.1 0.6c0.7 0.3 1.5 0.7 2 1.1 1.1 0.9 2.2 1.8 3.1 2.9 0.5 0.4 0.9 0.9 1.3 1.4 0.3 0.6 0.7 1.1 0.8 1.5 0.6 0.9 1 1.8 1.1 2.4 0.2 0.5 0.5 0.8 0.5 0.8 0 0-1-1.1-2.4-2.5l-2.5-2.5c-0.6-0.4-1-1-1.6-1.3l-1.6-1.1c-1.1-0.7-2.2-1.3-3.3-1.4h-1.6c-0.1 0.1-0.1 0.1-0.3 0.1-0.3 0.2-0.4 0.2-0.6 0.4-0.8 0.6-1.3 1.2-1.4 1.8-0.2 0.4-0.5 0.5-0.5 0.8v0.2z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m310.2 112.2c0-0.2 0.3-0.2 0.3-0.2l0.3-0.4 1.3-1.2c1.1-1 2.7-2.2 4.6-3.2 1.7-0.8 4.1-1.6 6.5-1.4 2.5 0.2 5.1 1.3 7.3 3.6 2.3 2.6 3.1 6.2 2.5 9.7-0.3 3.6-1.9 7.2-4.3 10.4-4.6 6.3-12.8 10.9-21.5 7.1-0.8-0.3-1.3-1.1-1.1-2l3.8-21.4c0.2-0.3 0.3-0.6 0.6-0.8l1.4 1.3c-1.4-1.3-1.4-1.3-1.7-1.5z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m325.2 114.3c6 3.3-3.3 21.8-16.7 18.3l2-11c2.9-3.4 9.8-9.6 14.7-7.3z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m327 118.7v-0.1c0-0.2 0-0.4-0.2-0.8-0.1-0.5-0.5-1.4-1.1-1.9-0.1-0.3-0.3-0.5-0.5-0.5-0.1 0-0.1-0.1-0.3-0.1h-0.3c-0.1 0-0.3 0-0.3-0.2h-1.1c-1.1 0-2.4 0.3-3.5 0.9-0.5 0.2-1.3 0.5-1.8 1l-1.7 1c-1.1 0.7-1.9 1.5-2.8 2-1.6 1.3-2.7 2.2-2.7 2.2 0 0 0.1-0.3 0.5-0.9 0.3-0.5 0.9-1.3 1.4-2.1 0.4-0.3 0.8-0.8 1.1-1.2 0.4-0.4 0.9-0.9 1.4-1.3 1.1-0.8 2.2-1.6 3.8-2.4 0.6-0.3 1.4-0.5 2.1-0.6 0.8-0.2 1.5-0.2 2.4-0.2h0.6c0.1 0 0.3 0 0.5 0.2 0.1 0 0.4 0.1 0.6 0.1 0.1 0 0.3 0.2 0.5 0.2l0.1 0.2h0.5c0.1 0.1 0.3 0.1 0.3 0.4 0.2 0.2 0.5 0.5 0.5 0.7 0.4 0.6 0.6 1.1 0.6 1.4v1.1c0 0.4 0 0.6-0.2 0.8-0.1 0-0.4 0.1-0.4 0.1z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m255.1 145.9h22.6c0 0 0.9 35.4 1.1 35.4 0 0-1.6 7.2-11.7 7.4-10 0.2-12.5-7.4-12.5-7.4 0.1-0.1 0.5-35.4 0.5-35.4z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s28",
    d: "m255.1 144h22.6c1.1 0 1.8 0.8 1.8 1.9v1.4c0 1 0 2.4 0.2 4 0 3.3 0.2 7.9 0.3 12.3 0.2 4.3 0.2 8.9 0.4 12.2 0 1.6 0 3 0.1 3.9v2.6c-0.1 0.1-0.1 0.6-0.3 1.1-0.3 0.7-0.9 1.8-1.9 2.9-2.1 2.2-5.5 4.2-11 4.4-5.5 0.1-9.1-2-11.3-4-1.1-1.1-1.9-2.2-2.4-3l-0.6-1c0-0.3-0.1-0.3-0.1-0.4v-0.2l1.7-0.5c0.5 1.2 3.5 7.3 12.5 7.1 6.9-0.2 10.1-3.5 11.2-5.7l-25-37.1c0-1.1 0.8-1.9 1.8-1.9zm-0.5 37.6q0-0.3 0-0.3l-1.3-35.4 1.4 35.7zm-1.3-35.7v5.4c0 1.6-0.1 3.5-0.1 5.6zm-0.1 11.1v2.2q0-1.1 0-2.2zm1.3 24.5l-1.8 0.5c0-0.2-0.2-0.5 0-0.7zm-1.4-13.8l-0.2 13.6v-5.5c0-2.3 0.1-5.1 0.2-8.1zm0.1-21.7l-0.5 35.4zm-0.1 17.5q0-2.1 0-4.2zm0 0q0 2.1 0 4zm1.4 17.9l-1.9-0.2z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m253.3 145.9c0-1.1 0.8-1.9 1.8-1.9h22.6c1.1 0 1.8 0.8 1.8 1.9h-1.8 1.8v1.4c0 1 0 2.4 0.2 4 0 3.3 0.2 7.9 0.3 12.3 0.2 4.3 0.2 8.9 0.4 12.2 0 1.6 0 3 0.1 3.9v2.1l-1.7-0.5 1.7 0.5v0.5c-0.1 0.1-0.1 0.6-0.3 1.1-0.3 0.7-0.9 1.8-1.9 2.9-2.1 2.2-5.5 4.2-11 4.4-5.5 0.1-9.1-2-11.3-4-1.1-1.1-1.9-2.2-2.4-3l-0.6-1c0-0.3-0.1-0.3-0.1-0.4v-0.2l1.8-0.5zm0 0l-0.6 35.3zm1.3 35.5l-1.8 0.5c0-0.1-0.1-0.5 0-0.6zm-1.2-35.6l24.9 37.2c-1.1 2.2-4.2 5.5-11 5.6-10.1 0.2-12.7-7.2-12.7-7.2zm0 0h1.8zm-0.3 35.2v-5.4c0-3.3 0.1-7.8 0.1-12.3 0-4.4 0.2-8.8 0.2-12.1v-5.4zm1.6 0.3l-1.8-0.2"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m256.5 151.5l22.6 2c0 0-0.2 4.6-0.2 8.4 0 0.6-6.5 0.9-7.2 1.1-5.7 0.3-11-0.8-16.3-2.5 0.4-4 1.1-9 1.1-9z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m223.8 95.8c1.7-15.6 9.9-29.9 26-34.6 8.2-2.4 17-2.5 25.3-1.6 8.4 0.8 17.1 2.1 24.8 5.7 13.5 6.6 10.9 13.8 11.1 28.3 0 1.4 8.9 9.1 8.7 10.6-0.2 3.3-0.2 6.3-0.5 9.6-0.9 7.3-2.7 14.6-5.7 21.2-3.6 8.1-9.1 15.5-16.5 20.5-4.2 2.9-9.1 5-14.1 6.2-8.1 2.2-16 2.4-24.2 0.2-5.7-1.4-10.9-3.8-15.6-7.1-7.8-5.4-13.5-13.5-16.6-22.3-2.6-7.6-3.7-15.5-3.7-23.4 0-4.4 0.5-8.7 1.1-13-0.3 0-0.3-0.1-0.1-0.3zm-1 0.5c0 0-0.1-6.2 0.6-13.9-0.7 7.9-0.6 13.9-0.6 13.9z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s32",
    d: "m242 156.6c-12.4-5.3-20.4-12.6-25-20.8-4.6-8.2-5.8-17.2-5.1-26.2 1.6-17.8 11.3-35.6 18.4-46.4zm-11.6-93.4l20.9-12.8c-9.5 2.6-17.2 7.1-21.3 13l0.4-0.2q0 0 0 0zm83 3.7c8.4 9.3 14 22.9 15.3 41.2 0.9 13.5-2.2 24.1-8 32.3-5.9 8.2-14 13.7-23.3 17.2-18.2 6.8-40.6 5.4-55.4-1zm-30.1-17.3c11.1 2.4 21.7 7.9 30.1 17.3zm-31.7 0.7c9.5-2.5 20.8-3 31.7-0.7zm-9.6 106.4l71.4-89.7zm71.4-89.8l-30-17.4zm-30.1-17.2l-31.7 0.7z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m220.3 118c0 0-7.1-2.1-11.1-17.9-2.8-10.6 0.4-33.5 13.6-44.4 7.9-6.3 10.1-3.5 10.1-3.5 0 0 1.9-7.6 16.8-14.1 48.4-21 60.5 1.8 67.5 20.6 9.5 25.6 4.7 44.7-45.9 28.1-20.4-6.6-33.3-9.9-33.3-9.9 0 0 0.2 6.6-4.1 15.9-4 9.5-13.8 19.8-13.8 19.8"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m207.2 100.5c-1.5-5.8-1.3-14.5 0.9-23.1 2.2-8.6 6.4-17.5 13.5-23.3l2.5 2.9c-6.2 5.1-10.1 13.1-12.2 21.3-2.2 8-2.2 16.2-0.9 21.1zm15-46.2c3.9-3.3 6.9-4.6 9-4.6q0.5 0 0.8 0c0.5-0.9 1.2-2.1 2.4-3.5 2.5-3 6.9-6.7 14.5-10l0.1 0.2c24.4-10.6 40.2-10.3 50.9-4.6 10.8 5.9 15.7 16.8 19.2 26.3l-3.7 1.2c-3.5-9.3-8-19.1-17.3-24.2-9.2-4.9-23.6-5.6-47.8 4.8-7.2 3.1-11 6.3-13.2 9-1.1 1.2-1.6 2.1-2 2.8-0.1 0.4-0.4 0.5-0.4 0.8v0.2l-0.1-0.1c-0.2 0.6-0.6 1.2-1.3 1.3-0.6 0.2-1.5-0.1-1.8-0.6h-0.6c-1 0-2.9 0.6-6.8 3.7zm98 29.8c-1-0.3-1.6-1.2-1.4-2.2 1.4-5.7 0-13.6-3.2-22.5l3.8-1.2c3.2 9 5 17.8 3.2 24.5-0.2 1.1-1.3 1.7-2.4 1.4zm-100.4 35.6h-0.1c-0.2 0-0.2-0.2-0.4-0.2-0.3 0-0.7-0.3-1.1-0.5-0.9-0.6-2-1.4-3.3-2.8-2.5-2.7-5.4-7.4-7.4-15.7l3.8-0.9c2 7.7 4.6 11.9 6.6 14.1 0.9 1.2 1.8 1.8 2.4 2.2 0.1 0.1 0.3 0.3 0.5 0.3h0.1l-0.5 1.9c-0.6 1.7-0.6 1.7-0.6 1.6zm16.3-26.1c-2.2 4.9-5.8 9.9-8.7 13.7-1.6 1.8-2.8 3.5-3.8 4.6l-1.7 1.6v0.2l-2.9-2.6 0.3-0.3c0.2-0.4 0.5-0.8 1.1-1.3q1.6-1.7 3.8-4.4c3-3.6 6.2-8.5 8.3-12.9zm81.2-35l1.9-0.7zm-108.1 41.3l1.9-0.6zm13.6-44.4l1.2 1.5zm26.9-17.5l-0.8-1.8z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s34",
    d: "m232.9 178.1h68.1c12.2 0 23.5 6.2 27.7 15.9l26.9 61.6c3.5 7.9 1.4 15.9-3.8 22-5.3 5.8-13.8 9.8-23.9 9.8h-122.3c-10.1 0-18.6-3.8-23.9-9.8-5.3-6.1-7.3-14.3-3.8-22l26.9-61.6c4.3-9.7 15.5-15.9 28.1-15.9z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s35",
    d: "m198 205.4c0-9 7.3-16.3 16.3-16.3h105.7c9 0 16.3 7.3 16.3 16.3v130.2c0 9-7.3 16.3-16.3 16.3h-105.7c-9 0-16.3-7.3-16.3-16.3z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s36",
    d: "m206.4 206.4c0-8.5 6.9-15.3 15.3-15.3h90.9c8.5 0 15.3 6.8 15.3 15.3v118.6c0 8.5-6.8 15.3-15.3 15.3h-90.9c-8.4 0-15.3-6.8-15.3-15.3z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s35",
    d: "m202.6 108.3c0-9 7.3-16.3 16.3-16.3h92.5c9 0 16.3 7.3 16.3 16.3v49.9c0 9-7.3 16.3-16.3 16.3h-92.5c-9 0-16.3-7.3-16.3-16.3z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s36",
    d: "m214 109.7c0-6.3 5.1-11.4 11.4-11.4h79.8c6.3 0 11.4 5.1 11.4 11.4v42.9c0 6.3-5.1 11.4-11.4 11.4h-79.8c-6.3 0-11.4-5.1-11.4-11.4z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m208.5 386.1c-7.2-1.7-13.2-3.6-17.3-6-2.2-1.1-3.9-2.4-5.2-3.8-1.2-1.5-1.9-3.1-1.9-5 0-1.8 0.7-3.5 1.9-4.9 1.3-1.4 3-2.7 5.2-3.8 4.1-2.2 10-4.4 17.3-6 14.3-3.5 34.2-5.4 56.1-5.4 21.8 0 41.7 1.9 56.1 5.4 7.1 1.6 13.1 3.6 17.3 6 2.1 1.1 3.8 2.4 5.1 3.8 1.2 1.4 1.9 3.1 1.9 4.9 0 1.9-0.7 3.5-1.9 5-1.3 1.4-3 2.7-5.1 3.8-4.2 2.2-10.1 4.3-17.3 6-14.4 3.5-34.3 5.4-56.1 5.4-21.9 0-41.8-2.2-56.1-5.4z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s38",
    d: "m342.1 374.8c-7.2 8.5-39.1 15-77.4 15-38.2 0-70.3-6.5-77.4-15z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m252.9 483.7c-0.9 0-1.8-0.7-1.8-1.8v-189.6c0-7.5 6-13.5 13.5-13.5 7.4 0 13.4 6 13.4 13.5v189.6c0 0.9-0.7 1.8-1.8 1.8z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m256.3 285.3c-0.9 0-1.7-0.6-1.7-1.7v-162.5c0-5.5 4.4-10 10-10 5.5 0 9.9 4.5 9.9 10v162.5c0 0.9-0.6 1.7-1.7 1.7z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s40",
    d: "m266.8 394.2c0.1 0.5 0 1-0.4 1.4-0.4 0.3-0.7 0.7-1.2 0.7-0.6 0-5.1 0.4-12.2 0.4-13 0-35.7-1.3-60.2-8.6-18.2-5.5-25.1-24.7-27.3-44-2.1-18.5 0-37.8 1.7-48.4-3.8-0.3-7-0.9-9.3-1.7-1.5-0.6-2.7-1.1-3.7-1.9-0.9-0.8-1.8-1.8-1.8-3.3 0-1.6 1.4-2.9 2.5-3.6 1.3-0.9 3-1.5 4.9-2 3.9-1.1 9.3-1.7 15.1-1.7 5.9 0 11.1 0.6 15.2 1.7 1.9 0.5 3.6 1.3 4.9 2 1.3 0.7 2.5 1.8 2.5 3.6 0 1.7-1.1 2.8-2.2 3.5-1.1 0.7-2.5 1.2-4.1 1.8-3 1-6.9 1.6-11.5 1.8-2.1 12.5-3.7 30.8-1.8 47.1 0.8 8.5 2.7 16.3 5.8 22.3 2.9 6 7.3 10.4 12.9 12 34.6 10.3 66.2 7.7 67 7.7 1.1 0 1.9 0.7 2.1 1.6z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s40",
    d: "m336.1 377.3c5.7-1.6 9.8-6 13-12 3-6.2 4.9-13.8 5.8-22.3 1.8-16.3 0.2-34.6-1.8-47.1-4.6-0.3-8.4-0.8-11.5-1.8-1.7-0.6-3.1-1.1-4.2-1.8-1.1-0.7-2.2-1.8-2.2-3.5 0-1.6 1.4-2.9 2.5-3.6 1.3-0.9 3-1.5 4.9-2 4.1-1.1 9.5-1.7 15.4-1.7 5.8 0 11.1 0.6 15.1 1.7 1.8 0.5 3.7 1.3 4.9 2 1.3 0.7 2.6 1.8 2.6 3.6 0 1.5-1 2.5-1.8 3.3-0.9 0.8-2.2 1.3-3.7 1.9-2.3 0.6-5.6 1.4-9.3 1.7 1.5 10.6 3.7 29.9 1.6 48.4-2.2 19.4-9 38.5-27.3 44-24.4 7.3-46.9 8.6-60.2 8.6-7.1 0-11.5-0.4-12-0.4-0.6 0-1-0.4-1.3-0.7-0.3-0.4-0.3-0.9-0.3-1.4l0.8-7.6c0.2-1.1 1.1-1.6 2-1.6 1 0.2 32.6 2.7 67-7.7z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m264.7 510.8c-8.5 0-15.5-6.9-15.5-15.4 0-8.6 7-15.5 15.5-15.5 8.6 0 15.5 6.9 15.5 15.5 0 8.5-6.9 15.4-15.5 15.4zm0-209.7c-8.5 0-15.5-7-15.5-15.5 0-8.6 7-15.5 15.5-15.5 8.6 0 15.5 6.9 15.5 15.5 0 8.5-6.9 15.5-15.5 15.5z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m264.6 402.1c-5.8 0-10.6-4.7-10.6-10.6 0-5.8 4.8-10.6 10.6-10.6 5.9 0 10.6 4.8 10.6 10.6 0 5.9-4.7 10.6-10.6 10.6z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m191 510.8c-8.6 0-15.5-6.9-15.5-15.4 0-8.6 6.9-15.5 15.5-15.5 8.5 0 15.4 6.9 15.4 15.5 0 8.5-6.9 15.4-15.4 15.4zm151.7 0c-8.5 0-15.4-6.9-15.4-15.4 0-8.6 6.9-15.5 15.4-15.5 8.5 0 15.4 6.9 15.4 15.5 0 8.5-6.9 15.4-15.4 15.4z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m342 483.7v2.2c0 3.1-4.6 5.6-10.1 5.6h-134.5c-5.5 0-10.1-2.5-10.1-5.6v-2.2c0-3.1 4.6-5.6 10.1-5.6h134.5c5.7 0 10.1 2.5 10.1 5.6z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m89.1 440.4h71.9v14h-71.7c-3.9 0-6.9-3-7.2-6.8-0.1-3.8 3.2-7.1 7-7.1zm69.4 31.4c0 3.7-3.2 6.7-7.1 6.7h-71.8v-14.1h72c3.8 0 7 3.4 6.9 7.4zm0 23.9c0 3.6-3.2 6.7-7.1 6.7h-71.8v-14.1h72c3.8 0 7 3.3 6.9 7.4z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s43",
    d: "m100.9 454.4h-11.8c-3.8 0-7-3-7.1-6.8-0.2-3.8 3.1-7.1 6.9-7.1h12.6c-3.9 0-6.9 3.2-6.9 7.1 0.2 3.6 2.9 6.6 6.3 6.8zm-21.4 24h12.7v-14h-12.7zm0 23.9h12.7v-13.9h-12.7zm22-47.9q-0.3 0-0.6 0z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m109.9 440.2v8.2c0 0.5-0.6 0.9-0.9 0.5l-2.4-1.8c-0.2-0.1-0.6-0.1-0.8 0l-2.3 1.8c-0.4 0.3-0.9 0-0.9-0.5v-8.2z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m106.4 447c-0.1 0-0.1 0.1-0.4 0.1l-2.4 1.8c-0.3 0.3-0.8 0-0.8-0.5v-8.2h3.6z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m138.1 464v8.3c0 0.5-0.5 0.6-1 0.5l-2.2-1.8c-0.3-0.2-0.6-0.2-0.8 0l-2.4 1.8c-0.3 0.4-0.9 0-0.9-0.5v-8.3z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m134.3 470.8c-0.2 0-0.2 0.2-0.4 0.2l-2.3 1.8c-0.5 0.1-1 0-1-0.5v-8.3h3.7z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m138.1 488.1v8.2c0 0.5-0.5 0.8-1 0.5l-2.2-1.8c-0.3-0.2-0.6-0.2-0.8 0l-2.4 1.8c-0.3 0.4-0.9 0-0.9-0.5v-8.2z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m134.3 494.8c-0.2 0-0.2 0.2-0.4 0.2l-2.3 1.8c-0.5 0.3-1 0-1-0.5v-8.2h3.7z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s46",
    d: "m82.1 447.6c0.3 3.7 3.3 6.6 7 6.6h72.8c0.8 0 1.3 0.5 1.3 1.3v2.7c0 0.8-0.5 1.3-1.3 1.3h-73c-6.5 0-12-5.4-11.8-12.2 0.1-6.5 5.6-11.9 12.2-11.9h72.8c0.8 0 1.3 0.5 1.3 1.3v2.7c0 0.8-0.5 1.4-1.3 1.4h-73c-3.7 0-6.7 3-7 6.8z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s47",
    d: "m109.3 459.5h-20.2c-6.5 0-12-5.4-11.9-12.2 0.3-6.5 5.7-11.9 12.3-11.9h20c-4.2 0-7.8 2.2-10 5.4h-10.4c-3.8 0-7 3-6.7 6.8 0.2 3.7 3.2 6.6 6.9 6.6h10.2c2 3.1 5.7 5.3 9.8 5.3z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m151.6 464.5h-73.1c-0.7 0-1.3-0.5-1.3-1.2v-2.7c0-0.8 0.6-1.3 1.3-1.3h72.9c6.6 0 12 5.2 12.2 11.9 0.2 6.7-5.3 12.1-12 12.1h-73.1c-0.7 0-1.3-0.5-1.3-1.2v-2.7c0-0.8 0.6-1.3 1.3-1.3h72.9c3.6 0 6.7-3 6.9-6.6 0-3.8-3-7-6.7-7z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s49",
    d: "m77.2 463.3v-2.7c0-0.8 0.6-1.3 1.3-1.3h12.5c-0.8 0-1.3 0.5-1.3 1.3v2.7c0 0.7 0.5 1.2 1.3 1.2h-12.5c-0.7 0-1.3-0.5-1.3-1.2zm13.8 20h-12.5c-0.7 0-1.3-0.5-1.3-1.2v-2.7c0-0.8 0.6-1.3 1.3-1.3h12.5c-0.8 0-1.3 0.5-1.3 1.3v2.7c0 0.7 0.5 1.2 1.3 1.2z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s50",
    d: "m151.6 488.4h-73.1c-0.7 0-1.3-0.5-1.3-1.3v-2.7c0-0.7 0.6-1.2 1.3-1.2h72.9c6.6 0 12 5.2 12.2 11.8 0.2 6.8-5.3 12.2-12 12.2h-73.1c-0.7 0-1.3-0.5-1.3-1.3v-2.7c0-0.7 0.6-1.2 1.3-1.2h72.9c3.6 0 6.7-3 6.9-6.7 0-3.6-3-6.9-6.7-6.9z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s51",
    d: "m77.2 487.1v-2.7c0-0.7 0.6-1.2 1.3-1.2h12.5c-0.8 0-1.3 0.5-1.3 1.2v2.7c0 0.8 0.5 1.3 1.3 1.3h-12.5c-0.7 0-1.3-0.5-1.3-1.3zm13.8 20.1h-12.5c-0.7 0-1.3-0.5-1.3-1.3v-2.7c0-0.7 0.6-1.2 1.3-1.2h12.5c-0.8 0-1.3 0.5-1.3 1.2v2.7c0 0.8 0.5 1.3 1.3 1.3z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m76.4 506.4v-2.7c0-1.4 1.1-2.5 2.5-2.5v-10.9c-1.4 0-2.5-1.1-2.5-2.6v-2.8c0-0.5 0.2-0.8 0.3-1.2-0.1-0.4-0.3-0.7-0.3-1.3v-2.7c0-1.4 1.1-2.5 2.5-2.5v-11c-1.4 0-2.5-1.1-2.5-2.5v-2.8c0-1.4 1.1-2.5 2.5-2.5h2.7c-3.4-2.6-5.5-6.5-5.5-10.9 0.3-7.3 6.3-13.2 13.6-13.2h72.8c1.5 0 2.6 1.1 2.6 2.6v2.8c0 1.4-1.1 2.5-2.6 2.5v2.4c0 0.7-0.6 1.3-1.2 1.3-0.8 0-1.3-0.6-1.3-1.3v-2.4h-48.2v6.4c0 1.4-1.7 2.3-3 1.4l-2-1.4-2.1 1.4c-1.2 0.9-3 0.2-3-1.4v-6.4h-12.2c-2.9 0-5.3 2.4-5.5 5.1-0.3 3.3 2.4 5.8 5.5 5.8h70.2v-2.3c0-0.8 0.6-1.3 1.3-1.3 0.8 0 1.4 0.5 1.4 1.3v2.3c1.4 0 2.5 1.1 2.5 2.6v2.7c0 1.4-1.1 2.5-2.5 2.5h-3c3.3 2.4 5.5 6.3 5.5 10.4 0 5.5-3.3 10.3-7.7 12.2 4.6 2 7.7 6.6 7.7 11.7 0 7.4-5.8 13.4-13.3 13.4h-32.6c-0.7 0-1.3-0.5-1.3-1.2 0-0.7 0.6-1.3 1.3-1.3h32.6c5.8 0 10.5-4.7 10.5-10.8 0-5.8-4.9-10.5-10.7-10.5h-72.9v2.5h73.1c4.5 0 8.1 3.7 8 8.2-0.2 4.4-3.8 7.9-8.2 7.9h-72.9v2.5h34.3c0.7 0 1.2 0.5 1.2 1.3 0 0.8-0.5 1.3-1.2 1.3h-34.3c-1.4 0-2.5-1.1-2.1-2.1zm4.9-5.5h70.5c2.9 0 5.4-2.4 5.4-5.4 0-3-2.4-5.6-5.4-5.6h-12.3v6.4c0 1.4-1.8 2.4-3 1.4l-2.1-1.4-1.9 1.4c-1.4 1-3.1 0.2-3.1-1.4v-6.4h-48.1zm50.6-5.8l1.3-0.9c0.7-0.5 1.7-0.5 2.3 0l1.3 0.9v-5.2h-4.9zm-42.8-37.1h73v-2.5h-72.8c-4.5 0-8.4-3.7-8.2-8.3 0.2-4.1 3.7-7.7 8-7.7h73v-2.6h-72.8c-5.8 0-10.5 4.8-10.8 10.6-0.2 6 4.7 10.9 10.6 10.5zm19.7-15.8h-4.9v5l1.3-0.8c0.6-0.6 1.6-0.6 2.3 0l1.3 0.8zm-30.3 40.2h72.9c6.4 0 10.7-5.1 10.7-10.8 0-5.8-4.9-10.6-10.7-10.6h-72.9v2.6h73.1c4.5 0 8.1 3.6 8 8.2-0.2 4.4-3.8 7.9-8.2 7.9h-72.9zm50.9-9.7v-6.4h-48.1v10.9h70.5c2.9 0 5.4-2.4 5.4-5.3 0-3.1-2.4-5.6-5.4-5.6h-12.3v6.4c0 1.4-1.8 2.4-3 1.4l-2.1-1.4-1.9 1.4c-1.4 1-3.1 0-3.1-1.4zm3.8-2.4c0.7-0.6 1.7-0.6 2.3 0l1.3 0.9v-5.1h-4.9v5.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloper);
export default __webpack_public_path__ + "static/media/developer.10122c629db616291a8764a5162b4631.svg";
export { ForwardRef as ReactComponent };